export default "__VITE_ASSET__0xld8V2B__"